import { createContext } from 'react';

export const MenuCloseContext = createContext<(() => void) | null>(null);
